// Exports
export default {
	"wrapper": "wrapper_LA1EY",
	"button": "button_bATbt"
};
